exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pad-top {\r\n  padding-top:25px;\r\n}\r\n\r\n.search-bar {\r\n  width: 90%;\r\n}\r\n\r\n.collection-guid {\r\n  min-width:350px;\r\n  width:350px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();